export const BENEFIT_SECTIONS = {
  ptt: {
    title: 'UTR PTT',
    logo: '/img/logos/utr_ptt.svg',
    benefits: [
      'Events offering $11+ million in prize money',
      'Tour Card offering $750+ in additional perks',
    ],
  },
  power: {
    title: 'UTR POWER',
    logo: '/img/logos/utr_power.svg',
    benefits: [
      '2 decimal ratings and in-depth analytics',
      'Discounts on travel, apparel, gear, and more',
    ],
  },
  globalPrivileges: {
    title: 'Global Privileges',
    logo: '/img/logos/partners/global_privileges.svg',
    benefits: [
      '$250+ in travel benefits and vouchers',
      'Up to 60% off on 1.4M+ hotels worldwide',
    ],
  },
  fabletics: {
    title: 'Fabletics',
    logo: '/img/logos/partners/fabletics.svg',
    description: '$1000+ in free membership, VIP prices (up to 50% off), quarterly rewards, & more.',
    footnote: 'USA billing ZIP required to access Fabletics.',
  },
};

export const UPSELL_CONTENT = {
  ptt: {
    subtitle: 'Enjoy compelling additional benefits including:',
    sections: [
      BENEFIT_SECTIONS.ptt,
      BENEFIT_SECTIONS.power,
      BENEFIT_SECTIONS.globalPrivileges,
      BENEFIT_SECTIONS.fabletics,
    ],
  },
  nonPtt: {
    subtitle: 'Enjoy compelling additional benefits including:',
    sections: [
      BENEFIT_SECTIONS.power,
      BENEFIT_SECTIONS.globalPrivileges,
      BENEFIT_SECTIONS.fabletics,
    ],
  },
  monthlyCta: 'UPGRADE TO POWER ANNUAL PLAN',
  freeCta: 'GET POWER ANNUAL PLAN',
  redirectNote: 'You\'ll be redirected back to complete event registration after you upgrade.',
  appleMessage: {
    title: 'Your Power subscription was purchased through Apple.',
    body: 'To upgrade to annual Power, please open the UTR Sports app on your iPhone or iPad, and upgrade your subscription there. You can also manage your subscription in ',
    bodyEmphasis: 'Apple Settings > Apple Account > Subscriptions.',
  },
};
